import { render } from "./archiveManager.vue?vue&type=template&id=a2db906c&scoped=true"
import script from "./archiveManager.vue?vue&type=script&lang=js"
export * from "./archiveManager.vue?vue&type=script&lang=js"

import "./archiveManager.vue?vue&type=style&index=0&id=a2db906c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2db906c"]])

export default __exports__